import Delete from "../../assets/icons/delete.svg";
import Member from "../../assets/icons/profilepic.png";
import Edit from "../../assets/icons/edit.svg";
import { Card, Button as Btn } from "antd";
import { Link } from "react-router-dom";
import EditColored from "../../assets/icons/coloredEdit.svg";

const ManageTeamCard = ({ edit, member, email, phone, openModal }) => {
  return (
    <Card className="border-2 border-gray-200 xl:w-111.7 mr-2 xl:mr-0 bg-white xl:relative">
      <div className="grid xl:grid-cols-4 xl:space-x-2">
        <div className="flex ml-1.5 mt-1">
          <div className="flex flex-col">
            <p className="font-medium text-primaryPurple text-lg mb-0">
              Member
            </p>
            <div className="flex">
              <img
                src={Member}
                alt="Member Icon"
                className="mr-1 h-4 w-4 rounded-full"
              />
              <p className="font-medium mt-1">{member}</p>
            </div>
          </div>
        </div>
        <div className="flex xl:ml-0 ml-1.5 mt-1">
          <div className="flex flex-col">
            <p className="font-medium text-primaryPurple text-lg mb-0">Email</p>
            <p className="font-medium mt-1 break-all">{email}</p>
          </div>
        </div>
        <div className="flex xl:ml-0 ml-1.5 flex-col mt-1">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Phone Number
          </p>
          <p className="font-medium mt-1">{phone}</p>
        </div>
        <div className="absolute flex xl:flex-row flex-col xl:right-0 right-3 xl:top-0 top-3 xl:p-2.5 xl:space-x-2 space-y-4 xl:space-y-0">
          <Link to={""} className="opacity-60 hover:cursor-default">
            <img src={edit ? Edit : EditColored} alt="Edit Icon" />
          </Link>

          <Btn className="border-none p-0" onClick={openModal}>
            <img src={Delete} alt="Delete Icon" />
          </Btn>
        </div>
      </div>
    </Card>
  );
};

export default ManageTeamCard;
